import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import FormikTimePicker from '../formik-fields/FormikTimePicker.jsx';

const GridFormikTimePicker = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikTimePicker {...props} />
    </Grid>
  );
};

GridFormikTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  pickerProps: PropTypes.object,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  gridProps: PropTypes.object.isRequired,
};

export default GridFormikTimePicker;
